// import "jquery-mousewheel";

const scrollFrame = {
    el: {
        scrollFrame: '.MJ__setFrame',
        frame: [],
        nav: '.MJ__scrollToFrame',
        scrollContainer: 'html',
        fullPageWrapper: 'body'
    },
    data: {
        totalFrame: 0,
        currentFrame: 0,
        currentFrameId: '',
        aniComplete: true,
        timeAnimation: 0,
    },
    func: {
        getTotalFrame: () => $(scrollFrame.el.scrollFrame).length,
        getScaleRatio: () => {
            if ($(scrollFrame.el.fullPageWrapper).length > 0) {
                return ($(scrollFrame.el.fullPageWrapper).attr("data-scale-ratio"));
            } else {
                return 1;
            }
        },
        getFrames: () => {
            $(scrollFrame.el.scrollFrame).each(function () {
                // scrollFrame.el.frame.push("#"+$(this).attr("id"));
                scrollFrame.el.frame.push({
                    el: "#" + $(this).attr("id"),
                    offsetTop: $("#" + $(this).attr("id")).offset().top
                })
            });
        },
        getFrameOffset: (frameId) => {
            for (let i = 0, len = scrollFrame.el.frame.length; i < len; i++) {
                if (scrollFrame.el.frame[i].el === frameId) {
                    return scrollFrame.el.frame[i].offsetTop;
                }
            }
            return 0;

        },
        scrollTo: (frameId, scrollOffset) => {
            // let scrollTop = $(frameId).offset().top;
            // let scaleRatio = scrollFrame.func.getScaleRatio();
            // console.log(scaleRatio);
            // scrollTop *= scaleRatio;
            // console.log(frameId);
            // console.log(scrollTop);
            let scrollTop = scrollFrame.func.getFrameOffset(frameId);
            scrollTop *= scrollFrame.func.getScaleRatio();

            // console.log(parseInt(scrollOffset));
            // console.log(scrollFrame.func.getScaleRatio());

            if (scrollOffset != undefined) {
                scrollTop += parseInt(scrollOffset) * scrollFrame.func.getScaleRatio();
            }

            // console.log(scrollTop);

            $(scrollFrame.el.scrollContainer).animate({
                scrollTop: scrollTop
            }, scrollFrame.data.timeAnimation, 'linear', function () {
                scrollFrame.data.aniComplete = true;
            });

            scrollFrame.func.activeNavBullet(frameId);
        },
        activeNavBullet: (frameId) => {
            if ($(scrollFrame.el.nav).length > 0) {
                $(scrollFrame.el.nav).removeClass("active");
                $(scrollFrame.el.nav).parent().parent().find('[href="' + frameId + '"]').addClass("active");
                // $(scrollFrame.el.nav).find('a').removeClass("active");
                // $(scrollFrame.el.nav).find('a[href="'+frameId+'"]').addClass("active");
            }
        },
        isOpeningPopup: () => {
            return $("html").hasClass("popup-opened");
        }
    },
    handleMousewheel: () => {
        $(window).on("mousewheel", function (e) {
            // e.preventDefault();
            // e.stopPropagation();
            if (!scrollFrame.func.isOpeningPopup()) {

                let deltaY = e.deltaY;

                // console.log(deltaY, scrollFrame.data.aniComplete, scrollFrame.data.currentFrameId);
                // console.log(deltaY > 0 && scrollFrame.data.aniComplete && (scrollFrame.data.currentFrame + 1 < scrollFrame.data.totalFrame));
                if (deltaY < 0 && scrollFrame.data.aniComplete && (scrollFrame.data.currentFrame + 1 < scrollFrame.data.totalFrame)) {
                    // Scroll down
                    scrollFrame.data.currentFrame++;
                    scrollFrame.data.aniComplete = false;
                    scrollFrame.data.currentFrameId = scrollFrame.el.frame[scrollFrame.data.currentFrame].el;
                    scrollFrame.func.scrollTo(scrollFrame.data.currentFrameId);

                } else if (deltaY > 0 && scrollFrame.data.aniComplete && (scrollFrame.data.currentFrame > 0)) {
                    // Scroll up
                    scrollFrame.data.currentFrame--;
                    scrollFrame.data.aniComplete = false;
                    scrollFrame.data.currentFrameId = scrollFrame.el.frame[scrollFrame.data.currentFrame].el;
                    scrollFrame.func.scrollTo(scrollFrame.data.currentFrameId);
                }
            }
        });
    },
    handleNav: () => {
        if ($(scrollFrame.el.nav).length > 0) {
            $(scrollFrame.el.nav).on("click", function (e) {
                e.preventDefault();
                let frameToScroll = $(this).attr("href");
                // if ($(this).attr("data-fts-selector").length > 0) {
                //     // console.log($(this).attr("data-fts-selector"));
                //     frameToScroll = "#" + $($(this).attr("data-fts-selector")).attr("id");
                //     // console.log(frameToScroll);
                // }

                for (let i = 0, len = scrollFrame.el.frame.length; i < len; i++) {
                    if (scrollFrame.el.frame[i].el === frameToScroll) {
                        scrollFrame.data.currentFrame = i;
                        scrollFrame.data.currentFrameId = frameToScroll;
                    }
                }
                var scrollOffset = $(this).attr("data-scroll-offset");
                scrollFrame.func.scrollTo(frameToScroll, scrollOffset);
            })
        }
    },
    followFrame: () => {
        $(document).ready(function () {
            let $frames = $(".MJ__setFollowFrame");
            let $followFrames = $(".MJ__followFrame");
            let currentActive = null;
        
            let observer = new IntersectionObserver((entries) => {
                let visibleFrames = entries.filter(entry => entry.isIntersecting).map(entry => $(entry.target));
        
                if (visibleFrames.length > 0) {
                    // Nếu có phần tử trong viewport, giữ lại phần tử đầu tiên
                    if (currentActive) currentActive.removeClass("MJ__currentFollowFrame");
                    currentActive = visibleFrames[0];
                    currentActive.addClass("MJ__currentFollowFrame");
                    if (varMS.callbacks && (typeof varMS.callbacks.scrollWatch === 'function')) {
                        varMS.callbacks.scrollWatch();
                    };
                } else {
                    // Nếu không có phần tử nào trong viewport, tìm phần tử gần nhất
                    let closestFrame = getClosestFrame();
                    if (closestFrame) {
                        if (currentActive) currentActive.removeClass("MJ__currentFollowFrame");
                        currentActive = closestFrame;
                        currentActive.addClass("MJ__currentFollowFrame");
                    }
                }
        
                // Cập nhật class "active" cho .MJ__followFrame tương ứng
                updateFollowFrames();
            }, { threshold: 0.5 });
        
            $frames.each(function () {
                observer.observe(this);
            });
        
            // Hàm tìm phần tử gần viewport nhất
            function getClosestFrame() {
                let closest = null;
                let minDistance = Infinity;
                let windowCenter = $(window).scrollTop() + $(window).height() / 2;
        
                $frames.each(function () {
                    let $this = $(this);
                    let frameCenter = $this.offset().top + $this.outerHeight() / 2;
                    let distance = Math.abs(frameCenter - windowCenter);
        
                    if (distance < minDistance) {
                        minDistance = distance;
                        closest = $this;
                    }
                });
        
                return closest;
            }
        
            // Hàm cập nhật class "active" cho .MJ__followFrame tương ứng
            function updateFollowFrames() {
                $followFrames.removeClass("active"); // Xóa tất cả class "active"
        
                if (currentActive) {
                    let index = $frames.index(currentActive);
                    if (index !== -1) {
                        $followFrames.eq(index).addClass("active"); // Thêm class "active" vào div tương ứng
                    }
                }
            }
        });
        

    },
    init: function () {
        this.followFrame();
        // console.log("scroll frame initial");
        // $(scrollFrame.el.scrollContainer).animate({
        //     scrollTop: 0
        // }, scrollFrame.data.timeAnimation, 'linear', function () { });

        scrollFrame.data.totalFrame = scrollFrame.func.getTotalFrame();
        scrollFrame.func.getFrames();

        // console.log(scrollFrame.el.frame)

        // console.log(scrollFrame.el);
        // console.log(scrollFrame.data);
        // scrollFrame.handleMousewheel();
        scrollFrame.handleNav();
    }
}
const isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

scrollFrame.init();


